// extracted by mini-css-extract-plugin
module.exports = {"about":"index_about__3x_yv","about__tab":"index_about__tab__2oVz-"};